"use client";

import { useDPC } from "@/lib/depict/dpc";

/**
 * Mounts the Depict tracking client (DPC) once for the lifetime of the app.
 * Renders nothing — the side effect is initializing DPC's `auto_observe` so it
 * picks up product cards (data-product-listing-result-id / data-search-result-id)
 * for impression + click tracking.
 *
 * Must live under CentraProvider so the Centra session token is available for
 * `dpc.setSessionId`.
 */
export const DepictTracking = () => {
	useDPC();
	return null;
};
